import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Stack,
  Table,
  Form,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { BrowserView } from "react-device-detect";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import PubSub from "pubsub-js";
import InfoPill from "../InfoPill";
import { ROUTES } from "../../constants/webRouting";
import { formatDateForView, getUserDetails } from "../../utils/helper";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/DateRangePicker/styles/index.css";
import PERMISSIONS from "../../constants/permissions";
import { formatDate } from "../../utils/helper";

const SiteVisitReportList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();

  const [body, setBody] = useState();
  const [assignUsers, setAssignUsers] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [dateRange, setDateRange] = useState([]);

  // ── Fetch all reports ──
  const fetchReports = async () => {
    const result = await fuziElevatorsApi.fetchSiteVisitReports();
    if (Array.isArray(result)) {
      setBody(result);
    } else {
      setBody([]);
    }
  };

  useEffect(() => {
    fetchReports();
    initUsers();
  }, []);

  const initUsers = async () => {
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some((p) =>
        userInfo?.permissions?.map((x) => x.name).includes(p)
      )
    ) {
      const result = await fuziElevatorsApi.fetchUsers();
      Array.isArray(result) &&
        setAssignUsers(
          result.map((u) => ({ value: u.id, label: u.username }))
        );
    }
  };

  // ── Filter handler ─
  const handleChange = (e) => {
    setFilterData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleClear = () => {
    setFilterData({});
    setDateRange([]);
    fetchReports();
  };

  // ── Table columns
  const header = [
    {
      title: "Enquiry No",
      prop: "enquiry_no",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <Link
          to={`${ROUTES.SITE_VISIT_REPORT.LIST}/${row.id}`}
          state={row}
        >
          {row.enquiry_no || "-"}
        </Link>
      ),
    },
    {
      title: "Created Date",
      prop: "createddate",
      isFilterable: true,
      isSortable: true,
      cell: (row) =>
        row?.createddate ? formatDateForView(row.createddate) : "-",
    },
    {
      title: "Customer Name",
      prop: "customer_name",
      isFilterable: true,
    },
    {
      title: "Site Address",
      prop: "site_address",
      isFilterable: true,
    },
    {
      title: "Mobile",
      prop: "phone",
      isFilterable: true,
    },
    {
      title: "Elevator Type",
      prop: "elevator_type",
      isFilterable: true,
    },
    {
      title: "Motor",
      prop: "motor",
      isFilterable: true,
    },
    {
      title: "Stops",
      prop: "total_stops",
      isFilterable: true,
    },
    {
      title: "Engineer",
      prop: "engineer_name",
      isFilterable: true,
    },
    {
      title: "Visit Date",
      prop: "site_visit_date",
      isFilterable: true,
      isSortable: true,
      cell: (row) =>
        row?.site_visit_date ? formatDateForView(row.site_visit_date) : "-",
    },
    // {
    //   title: "Assigned Users",
    //   prop: "assigned_users",
    //   isFilterable: true,
    // },
    // {
    //   title: "Status",
    //   prop: "status",
    //   isFilterable: true,
    //   cell: (row) => (
    //     <span
    //       className="badge rounded-pill"
    //       style={{
    //         background:
    //           row.status === "Pending"
    //             ? "#f59e0b"
    //             : row.status === "Complete"
    //             ? "#10b981"
    //             : "#6b7280",
    //         color: "#fff",
    //         padding: "6px 12px",
    //       }}
    //     >
    //       {row.status || "Pending"}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Created By",
    //   prop: "createdbyname",
    //   isFilterable: true,
    // },
  ];

  const labels = { beforeSelect: " " };

  return (
    <Container fluid>
      <DatatableWrapper
        body={body && Array.isArray(body) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50],
          },
        }}
        sortProps={{ initialState: { prop: "createddate", order: "desc" } }}
      >
        {/* ── Filters Row ─────────────────────── */}
        <Row>
          {/* Status Filter */}
          {/* <Col lg={2}>
            <Form.Group className="mt-2">
              <Form.Label className="form-view-label">Status</Form.Label>
              <Form.Select
                name="status"
                value={filterData?.status || ""}
                onChange={handleChange}
              >
                <option value="">---All---</option>
                <option value="Pending">Pending</option>
                <option value="Complete">Complete</option>
              </Form.Select>
            </Form.Group>
          </Col> */}

          {/* Elevator Type Filter */}
          <Col lg={2}>
            <Form.Group className="mt-2">
              <Form.Label className="form-view-label">Elevator Type</Form.Label>
              <Form.Select
                name="elevator_type"
                value={filterData?.elevator_type || ""}
                onChange={handleChange}
              >
                <option value="">---All---</option>
                {[
                  "Passenger",
                  "Passenger cum Goods",
                  "Passenger cum Stretcher",
                  "Passenger cum Bed",
                  "Goods",
                ].map((v) => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Assigned Users Filter */}
          <Col lg={2}>
            <Form.Group className="mt-2">
              <Form.Label className="form-view-label">Assigned Users</Form.Label>
              <Select
                isMulti
                className="z-3"
                placeholder="Select users"
                options={assignUsers}
                onChange={(e) =>
                  handleChange({ target: { name: "owner_ids", value: e } })
                }
                value={filterData?.owner_ids || []}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* ── Actions Row ── */}
        <Row className="align-items-end mt-2">
          <Col>
            <Filter
              classes={{
                inputGroup: "",
                input: "",
                clearButton: "btn-custom",
              }}
            />
          </Col>

          <Col md={1}>
            <PaginationOptions labels={labels} />
          </Col>

          <Col>
            <DateRangePicker
              value={dateRange}
              onChange={(e) => setDateRange(e)}
              character=" – "
            />
          </Col>

          <Col className="py-1">
            <BrowserView>
              <div className="d-flex py-1 px-2">
                <InfoPill
                  left="Total"
                  right={body?.length}
                  rightClasses="bg-custom text-white border-white fw-bold"
                  leftClasses="bg-white text-danger fw-bold"
                />
              </div>
            </BrowserView>
          </Col>

          <Col
            xs={12}
            sm={6}
            lg={3}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            <Stack direction="horizontal" gap={2}>
              <Button variant="secondary" size="sm" onClick={handleClear}>
                <i className="fa fa-refresh" aria-hidden="true" />
              </Button>

              {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_SITE_VISIT].some(
                (p) =>
                  userInfo?.permissions?.map((x) => x.name).includes(p)
              ) && (
                <Button
                  size="sm"
                  className="btn-create"
                  onClick={() =>
                    navigate(`${ROUTES.SITE_VISIT_REPORT.LIST}/e`)
                  }
                >
                  New Site Visit Report
                </Button>
              )}
            </Stack>
          </Col>
        </Row>

        {/* ── Table ── */}
        <div className="table-scroll my-3">
          <Table striped className="shadow rounded sm my-4">
            <TableHeader
              classes={{ th: "bg-custom text-white sticky-header" }}
            />
            {body && Array.isArray(body) ? (
              <TableBody />
            ) : (
              <tbody>
                <tr>
                  <td colSpan={100} align="center">
                    <Spinner />
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>

        <Pagination
          classes={{
            buttonGroup: "btn-custom",
            button: "bg-custom border-white",
          }}
        />
      </DatatableWrapper>
    </Container>
  );
};

export default SiteVisitReportList;